import { SCHEMA_SERVICE_NAME, SchemaServiceProvider } from './schema'
import { TECHNICAL_PERMISSION_SERVICE_NAME, TechnicalPermissionService } from './technical-permission'

import { ACTION_SERVICES_MODULE_NAME } from './action'
import { ALARM_SERVICES_MODULE_NAME } from './alarm'
import { ALARM_DEFINITION_SERVICES_MODULE_NAME } from './alarm-definition'
import { ALARM_GROUP_SERVICES_MODULE_NAME } from './alarm-group/index'
import { ATTACHEMNT_SERVICES_MODULE_NAME } from './attachments'
import { CONFIGURATION_PROFILE_SERVICES_MODULE_NAME } from './configuration-profile'
import { CONSUMER_SERVICES_MODULE_NAME } from './consumer'
import { CONTROLS_SERVICES_MODULE_NAME } from './controls'
import { DATA_TYPE_SERVICES_MODULE_NAME } from './data-type'
import { DATA_TYPE_GROUP_SERVICES_MODULE_NAME } from './data-type-group'
import { DEPOSITORY_SERVICES_MODULE_NAME } from './depository'
import { DEVICE_SERVICES_MODULE_NAME } from './device'
import { DEVICE_CONNECTIONS_SERVICES_MODULE_NAME } from './device-connection'
import { DISTRIBUTOR_SERVICES_MODULE_NAME } from './distributor'
import { EXTENDED_PARAMETERS_SERVICES_MODULE_NAME } from './extended-parameters'
import { GRID_SERVICES_MODULE_NAME } from './grid'
import { GROUPING_LOCATION_SERVICES_MODULE_NAME } from './grouping-locations'
import { ISSUE_SERVICES_MODULE_NAME } from './issue'
import { EXPORT_SERVICES_MODULE_NAME } from './export'
import { KINGSPAN_CONFIGURATION_FORM_SERVICES_MODULE_NAME } from '../modules/locations/location-configuration-form-kingspan/service'
import { LOCATION_SERVICES_MODULE_NAME } from './location'
import { METER_SERVICES_MODULE_NAME } from './meter'
import { PEC_GLIWICE_DATA_TYPE_GROUP_CREATE_EDIT_FORM_SERVICES_MODULE_NAME } from '../modules/data-type-groups/data-type-group-configuration-form-pec-gliwice/services'
import { OPERATOR_GROUP_SERVICES_MODULE_NAME } from './operator-group'
import { OPERATOR_SERVICES_MODULE_NAME } from './operator'
import { ORDER_SERVICES_MODULE_NAME } from './order'
import { PACKAGE_SERVICES_MODULE_NAME } from './package'
import { REFERENCE_TYPE_SERVICES_MODULE_NAME } from './reference-type'
import { REPORT_SERVICES_MODULE_NAME } from './report'
import { ROUTE_SERVICES_MODULE_NAME } from './route'
import { SYSTEM_SERVICES_MODULE_NAME } from './system'
import { SUPPLIER_SERVICES_MODULE_NAME } from './supplier'
import { TARIFF_SERVICES_MODULE_NAME } from './tariff'
import { TASK_SERVICES_MODULE_NAME } from './task'

export const SERVICES_MODULE_NAME = 'simax.services'

const servicesModule = angular.module(SERVICES_MODULE_NAME, [
    ACTION_SERVICES_MODULE_NAME,
    ALARM_SERVICES_MODULE_NAME,
    ALARM_DEFINITION_SERVICES_MODULE_NAME,
    ALARM_GROUP_SERVICES_MODULE_NAME,
    ATTACHEMNT_SERVICES_MODULE_NAME,
    CONFIGURATION_PROFILE_SERVICES_MODULE_NAME,
    CONSUMER_SERVICES_MODULE_NAME,
    CONTROLS_SERVICES_MODULE_NAME,
    DATA_TYPE_SERVICES_MODULE_NAME,
    DATA_TYPE_GROUP_SERVICES_MODULE_NAME,
    DEPOSITORY_SERVICES_MODULE_NAME,
    DEVICE_SERVICES_MODULE_NAME,
    DEVICE_CONNECTIONS_SERVICES_MODULE_NAME,
    DISTRIBUTOR_SERVICES_MODULE_NAME,
    EXPORT_SERVICES_MODULE_NAME,
    EXTENDED_PARAMETERS_SERVICES_MODULE_NAME,
    GRID_SERVICES_MODULE_NAME,
    GROUPING_LOCATION_SERVICES_MODULE_NAME,
    ISSUE_SERVICES_MODULE_NAME,
    KINGSPAN_CONFIGURATION_FORM_SERVICES_MODULE_NAME,
    LOCATION_SERVICES_MODULE_NAME,
    METER_SERVICES_MODULE_NAME,
    OPERATOR_GROUP_SERVICES_MODULE_NAME,
    OPERATOR_SERVICES_MODULE_NAME,
    ORDER_SERVICES_MODULE_NAME,
    PACKAGE_SERVICES_MODULE_NAME,
    PEC_GLIWICE_DATA_TYPE_GROUP_CREATE_EDIT_FORM_SERVICES_MODULE_NAME,
    REFERENCE_TYPE_SERVICES_MODULE_NAME,
    REPORT_SERVICES_MODULE_NAME,
    ROUTE_SERVICES_MODULE_NAME,
    SYSTEM_SERVICES_MODULE_NAME,
    SUPPLIER_SERVICES_MODULE_NAME,
    TARIFF_SERVICES_MODULE_NAME,
    TASK_SERVICES_MODULE_NAME
])

servicesModule.provider(SCHEMA_SERVICE_NAME, SchemaServiceProvider)

servicesModule.service(TECHNICAL_PERMISSION_SERVICE_NAME, TechnicalPermissionService)

//@deprecated Use named export i.e. import { SERVICES_MODULE_NAME } from '../../services'
export default SERVICES_MODULE_NAME